import type { PreloadedQuery } from 'react-relay';
// eslint-disable-next-line jira/import-whitelist
import ENTITLEMENTS_CUSTOMER_QUERY, {
	type EntitlementsQuery,
} from '@jira/servicedesk__customer-details/src/__generated__/EntitlementsQuery.graphql.ts';
// eslint-disable-next-line jira/import-whitelist
import { createRelayResource } from '@jira/platform__graphql-relay-utils/src/services/resources/index.tsx';
import type { RouteResource } from '@atlassian/react-resource-router';

export const EntitlementsQueryResource: RouteResource<
	PreloadedQuery<EntitlementsQuery, Record<string, unknown>>
> = createRelayResource<EntitlementsQuery>({
	type: 'ENTITLEMENTS_CUSTOMER_QUERY',
	getQuery: ({ match }, { tenantContext }) => ({
		parameters: ENTITLEMENTS_CUSTOMER_QUERY,
		variables: {
			accountId: String(match.params.customerId),
			cloudId: tenantContext.cloudId,
		},
		options: { fetchPolicy: 'store-and-network' },
	}),
});
